function addEvents(...args) {
  const [target, handlers] = args;

  for (const key in handlers) {
    target.on(key, handlers[key]);
  }

  return () => {
    for (const key in handlers) {
      target.off(key, handlers[key]);
    }
  };
}

export { addEvents };